export default "__VITE_ASSET__Dwqfk2do__"